import { useEffect } from 'react'

export function useStudyCreationBeforeUnload(shouldWarn: boolean) {
  useEffect(() => {
    if (!shouldWarn) return

    const handler = (e: BeforeUnloadEvent) => {
      e.preventDefault()
      e.returnValue = ''
    }
    window.addEventListener('beforeunload', handler)
    return () => window.removeEventListener('beforeunload', handler)
  }, [shouldWarn])
}
